import { Box, Typography, Button } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useSync } from '../shared/contexts/SyncContext';

export const OfflinePage: React.FC = () => {
  const { isOnline, triggerSync } = useSync();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        gap: 2,
        color: '#666',
      }}
    >
      <WifiOffIcon sx={{ fontSize: 64, color: '#bbb' }} />
      <Typography variant="h6" sx={{ color: '#555' }}>
        No data available offline
      </Typography>
      <Typography variant="body2" align="center" sx={{ maxWidth: 340 }}>
        Connect to the network and sync to access the product catalogue offline.
      </Typography>
      {isOnline && (
        <Button variant="contained" onClick={triggerSync} sx={{ mt: 1, bgcolor: '#A55DA0' }}>
          Sync Now
        </Button>
      )}
    </Box>
  );
};

export default OfflinePage;
